import React, { useEffect, useState } from 'react'
import DashboardLayout from '../../layoutcontainers/DashboardLayout'
import { Card, CardContent, CardHeader, Grid, Grid2, Stack } from '@mui/material'
import MaterialTypography from '../../components/MaterialTypography'
import MaterialDataGrid from '../../components/MaterialDataGrid'
import MaterialButton from '../../components/MaterialButton'
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom'
import MaterialBox from '../../components/MaterialBox'
import MaterialSelect from '../../components/MasterSelect'
import BASEURL from '../Utils/Baseurl'
import axios from 'axios'
import { gql } from 'graphql-request'
function Bonus() {
    const navigate = useNavigate();
    const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const [year, month, day] = dateStr.split("-");
        return `${day}-${month}-${year}`;
      };

    const columns = [
        // {
        //     field: 'id',
        //     headerName: 'S.No.',
        //     width: 1,
        //     disableColumnMenu: true,
        //     editable: false,
        //     sortable: true
        // },
        {
            field: 'empid',
            headerName: 'Emp. ID',
            flex: 1,
            disableColumnMenu: true,
            editable: false,
            sortable: true
        },
        {
            field: 'firstName',
            headerName: 'Employee Name',
            flex: 1,
            disableColumnMenu: true,
            editable: false,
            sortable: true
        },
        {
            field: 'bonusAmount',
            headerName: "Bonus",
            flex: 1,
            disableColumnMenu: true,
            editable: false,
            sortable: true
        },
        {
            field: 'sumOfBasic',
            headerName: "Basic Pay",
            flex: 1,
            disableColumnMenu: true,
            editable: false,
            sortable: true
        },
        {
            field: 'bonusType',
            headerName: "Bonus Type",
            flex: 1,
            disableColumnMenu: true,
            editable: false,
            sortable: true
        },
        {
            field: 'employeeCategory',
            headerName: "Category",
            flex: 1,
            disableColumnMenu: true,
            editable: false,
            sortable: true
        },
        {
            field: 'employeeType',
            headerName: "Type",
            flex: 1,
            disableColumnMenu: true,
            editable: false,
            sortable: true
        },
        {
            field: 'branch',
            headerName: "Branch",
            flex: 1,
            disableColumnMenu: true,
            editable: false,
            sortable: true
        },
        {
            field: 'createdAt',
            headerName: "Created At",
            flex: 1,
            disableColumnMenu: true,
            editable: false,
            sortable: true
        },

    ];

    const getAllBonuses = gql`
query allBonuses{
  allBonuses {
    id
    employee{
      id
      firstName
      lastName
      empid
      category
      branch
    }
    month
    year
    bonusType
    employeeCategory
    employeeType
    branch
    shift
    sumOfBasic
    percentage
    bonusAmount
    createdAt
  }
}`;

    const [rows, setRows] = useState([]);

    const getAllBonus = async () => {
        try {
            const response = await axios.post(BASEURL, {
                query: getAllBonuses
            });

            const bonuses = response.data?.data?.allBonuses || [];

            const formattedData = bonuses.map((bonus, index) => ({
                id:bonus.id ,
                firstName: bonus.employee.firstName+" "+bonus?.employee?.lastName,
                empid: bonus.employee.empid,
                month: bonus.month,
                year: bonus.year,
                bonusType: bonus.bonusType,
                employeeCategory: bonus.employeeCategory,
                employeeType: bonus.employeeType,
                branch: bonus.branch,
                shift: bonus.shift,
                sumOfBasic: bonus.sumOfBasic,
                percentage: bonus.percentage,
                bonusAmount: bonus.bonusAmount,
                createdAt: formatDate(bonus.createdAt.slice(0, 10)),
            }));

            setRows(formattedData);
        } catch (error) {
            console.error("Error fetching Data", error);
        }
    };

    useEffect(() => {
        getAllBonus();

    }, []);

    const handleRowClick = (e) => {

        if (e?.id) {
            navigate('/bonus/add-bonus', { state: { id: e?.id } });
        }
    };

    return (

        <DashboardLayout>
            <Card>
                <CardHeader title={(
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={2}
                    >
                        <Stack direction="column" spacing={0}>
                            <MaterialTypography variant="h5" fontWeight="medium">
                                Bonus Details
                            </MaterialTypography>
                        </Stack>
                        <MaterialButton
                            variant="gradient"
                            color="dark"
                            size="small"
                            startIcon={<AddIcon />}
                            onClick={() => {
                                navigate("/bonus/add-bonus");
                            }}
                        >
                            Bonus
                        </MaterialButton>

                    </Stack>
                )} />
                <CardContent sx={{ minHeight: "20vh" }}>
                    <MaterialDataGrid
                        rows={rows || null}
                        columns={columns || null}
                        onRowClick={handleRowClick}
                        localeText={{
                            noRowsLabel: (
                                <Stack direction="column" alignItems="center" justifyContent="center" spacing={1}>
                                    <MaterialTypography variant="body2" fontWeight="medium" color="text">
                                        No Bonus Details found
                                    </MaterialTypography>
                                    <MaterialTypography variant="caption" color="text">
                                        You have not yet added any Bonus details. Please Click the Add Bonus Button to Add Bonus Details.
                                    </MaterialTypography>
                                </Stack>
                            )
                        }}>

                    </MaterialDataGrid>
                </CardContent>
            </Card>
        </DashboardLayout>
    )
}

export default Bonus